export default {
    format: {},
    autodetect: []
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/io/input.js
// module id = 27
// module chunks = 6